/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function($){ 

    //console.log("Testing... 20 Dec");

    var vat = 20; // VAT rate to use
  
    /* ============================================================= */
    // Cart calcs on page load **** START ****
    /* ============================================================= */
    
    console.log("Fire event!");

    var elSubTotal = $(".js-cart-shipping-subtotal");         
    var elShipping = $(".js-cart-shipping-rate");
    var elVat = $(".js-cart-vat");        
    var elCartTotal = $(".js-cart-total");

    // Handle the sub total
    var subTotal = elSubTotal.text(); 
    subTotal = parsePotentiallyGroupedFloat(subTotal);
    //console.log("newSubTotal is: " + subTotal);

    // Other required vars        
    var calculatedShippingCost;
    var cartTotalExVAT; 
    var cartTotal; 

    $.ajax({  
        type:'post',
        url: "https://drainagesuppliesdirect.co.uk/cart/shipping_rates.json?shipping_address%5Bzip%5D=SE1+3SY&shipping_address%5Bcountry%5D=United+Kingdom",
        dataType: 'json', 
        success: function(result){               
            
            // Calculations
            calculatedShippingCost = result["shipping_rates"][0]["price"];
            console.log("Returned RATE: " + calculatedShippingCost);
            
            cartTotalExVAT = +subTotal + +calculatedShippingCost; // Cart total (ex Vat)
            cartTotal = ((cartTotalExVAT/100) * (vat+100)).toFixed(2); // Calc VAT
            totalVAT = (cartTotal - cartTotalExVAT).toFixed(2);

            // Set values
            elShipping.text(calculatedShippingCost);
            elVat.text(totalVAT);
            elCartTotal.text(cartTotal);

        },
        error : function(request,error){
            console.log("====== ERROR AFTER CART UPDATE======");
        }
    }); 

    // The cart and minicart updates
    document.addEventListener('cart:rerendered', function(event) {

        console.log("Fire event!");

        var elSubTotal = $(".js-cart-shipping-subtotal");         
        var elShipping = $(".js-cart-shipping-rate");
        var elVat = $(".js-cart-vat");        
        var elCartTotal = $(".js-cart-total");

        // Handle the sub total
        var subTotal = elSubTotal.text(); 
        subTotal = parsePotentiallyGroupedFloat(subTotal);
        //console.log("newSubTotal is: " + subTotal);

        // Other required vars        
        var calculatedShippingCost;
        var cartTotalExVAT; 
        var cartTotal; 
        
        $.ajax({  
            type:'post',
            url: "https://drainagesuppliesdirect.co.uk/cart/shipping_rates.json?shipping_address%5Bzip%5D=SE1+3SY&shipping_address%5Bcountry%5D=United+Kingdom",
            dataType: 'json',
            success: function(result){               
                
                // Calculations
                calculatedShippingCost = result["shipping_rates"][0]["price"];
                console.log("Returned RATE: " + calculatedShippingCost);
                
                cartTotalExVAT = +subTotal + +calculatedShippingCost; // Cart total (ex Vat)
                cartTotal = ((cartTotalExVAT/100) * (vat+100)).toFixed(2); // Calc VAT
                totalVAT = (cartTotal - cartTotalExVAT).toFixed(2);

                // Set values
                elShipping.text(calculatedShippingCost);
                elVat.text(totalVAT);
                elCartTotal.text(cartTotal);

            },
            error : function(request,error){
                console.log("====== ERROR AFTER CART UPDATE======");
            }
        }); 
    });
  
    function parsePotentiallyGroupedFloat(stringValue) {
        stringValue = stringValue.trim();
        var result = stringValue.replace(/[^0-9]/g, '');
        if (/[,\.]\d{2}$/.test(stringValue)) {
            result = result.replace(/(\d{2})$/, '.$1');
        }
        return parseFloat(result);
    }

  
  // Quick Help Section (beneath search) 
  
    var d = new Date();
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";

    var currDay = weekday[d.getDay()];
    //console.log("Current day is " + n);

    var openText = "";

    if(currDay == "Monday" || currDay == "Tuesday" || currDay == "Wednesday" || currDay == "Thursday" || currDay == "Friday" ){
        openText = "Open today 8:00am – 4:00pm";
    }else{
        openText = "Closed Today";
    }

    $(".js-open-text").text(openText);


   /* ============================================================= */
    // Show/Hide full descriptions
    /* ============================================================= */

    $(".js-toggle-full-desc").click(function(e){
        e.preventDefault();

        var curr_btn = $(this);

        // Handle the full desc
        $(".page-desc-meta-output__full").toggle();

        // Handle the read more button
        curr_btn.text('');

        // Toggle a class
        curr_btn.toggleClass("js-toggle-full-desc--open");

        if(curr_btn.hasClass("js-toggle-full-desc--open")){
            curr_btn.text('Show Less');
        }else{
            curr_btn.text('Read More');
        }
    });

})(jQuery);  
